// Событийное API праздничной анимации.
// Любой экран может вызвать celebrateEarned(сумма) — компонент <Celebration/>,
// смонтированный один раз в index.js, покажет фейерверк и сумму.
// Суммы передаются в рублях, как в updateMoney; в валюту приложения
// (💎 / 🍊 / ₽) переводятся при показе — тем же множителем, что и везде.
import { getMoneyType, getSmoozieMultiplier } from '../pages_android/custom_views/insta_custom_views/utils_android/UtilsAndroid';

export const CELEBRATE_EVENT = 'app:celebrate';

// Хронометраж праздника (мс от события). Сумма показывается крупно,
// затем «рассыпается» на монеты, которые летят в баланс в шапке;
// счётчик в шапке начинает «докручиваться», когда долетает первая монета.
export const TIMING = {
    earnedStay: 2000,        // сколько крупная сумма на экране (продлевается, если начислили ещё)
    mergeStay: 2000,         // после повторного начисления — столько же, монеты прилетят вовремя
    coinFlight: 900,         // монета «выпрыгивает» из суммы и долетает до шапки
    pendingStay: 2300,       // «отчёт отправлен»
    syncedArrive: 520        // компактный «+N» долетает до баланса
};
const ARRIVE_MS = {
    earned: TIMING.earnedStay + TIMING.coinFlight,
    synced: TIMING.syncedArrive
};

// Когда в шапку прилетят монеты (Date.now()-время) и от какого праздника.
let arrival = { at: 0, kind: '' };

function emit(kind, rubles, title) {
    const amount = parseFloat(rubles) || 0;
    // «Отчёт отправлен» — без суммы: денег за отчёт ещё нет
    if (!(amount > 0) && kind !== 'pending') return;
    const now = Date.now();
    // «На проверке» баланс не меняет; компактное начисление, пока монеты
    // большого праздника ещё летят, вливается в него — шапка ждёт те же монеты.
    const bigInProgress = arrival.kind === 'earned' && arrival.at > now;
    if (kind === 'earned') {
        arrival = { at: now + ARRIVE_MS.earned, kind: 'earned' };
    } else if (kind === 'synced' && !bigInProgress) {
        arrival = { at: now + ARRIVE_MS.synced, kind: 'synced' };
    }
    try {
        window.dispatchEvent(new CustomEvent(CELEBRATE_EVENT, { detail: { kind: kind, amount: amount, title: title } }));
    } catch (e) { /* очень старый WebView без CustomEvent — просто без анимации */ }
}

// Задание засчитано, деньги уже на балансе — большой праздник с фейерверком.
// title — своя надпись вместо «Задание выполнено!» (например, выигрыш в розыгрыше)
export const celebrateEarned = (rubles, title) => emit('earned', rubles, title);

// Баланс вырос после синхронизации с сервером (Instagram / TikTok-задания) —
// компактная версия: «+N» влетает в баланс, без затемнения экрана.
export const celebrateSynced = (rubles) => emit('synced', rubles);

// Отчёт отправлен: галочка и «Отчёт отправлен» с салютом, без суммы —
// деньги начислят только после проверки, баланс не меняется.
export const celebrateReportSent = () => emit('pending', 0);

// Праздник уточняет момент прилёта монет: раньше — если его закрыли тапом,
// сразу — когда первая монета долетела (или летать нечему).
export const setCoinsArrival = (msFromNow) => {
    if (arrival.kind === 'earned') {
        arrival = { at: Date.now() + Math.max(0, msFromNow), kind: 'earned' };
    }
};

// Сколько ещё ждать, прежде чем крутить счётчик баланса в шапке
// (шапка спрашивает повторно, пока ждёт, — так учитываются уточнения выше).
export const getHeaderCountDelay = () => Math.max(0, arrival.at - Date.now());

export const prefersReducedMotion = () => {
    try {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
        return false;
    }
};

// Рубли → число в валюте приложения (как в списке заданий: сумма × множитель).
export const toDisplayAmount = (rubles) => Math.round(parseFloat(rubles) * getSmoozieMultiplier() * 100) / 100;

const decimalsOf = (value) => (Math.abs(value - Math.round(value)) < 0.005 ? 0 : 2);

// 1234.5 → «1 234,50»; число знаков после запятой берём у итоговой суммы,
// чтобы во время «прокрутки» цифры не прыгали.
export const formatAmount = (value, decimals) => {
    const d = decimals === undefined ? decimalsOf(value) : decimals;
    try {
        return Number(value).toLocaleString('ru-RU', { minimumFractionDigits: d, maximumFractionDigits: d });
    } catch (e) {
        return Number(value).toFixed(d);
    }
};

export const amountDecimals = decimalsOf;

export const currencyLabel = (isUpmob) => String(getMoneyType(isUpmob)).trim();
